"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    SwapType: {
      _enum: ['Buy', 'Sell']
    },
    AmountEvaluation: {
      accountAmount: 'Balance',
      poolAmount: 'Balance'
    },
    PoolLiquidityAmount: {
      baseAmount: 'Balance',
      quoteAmount: 'Balance',
      ownership: 'Balance'
    }
  }
};
exports.default = _default;